export default {
  presenter: 'lutherova',
  title: 'O odnímaní zodpovednosti',
  subtitle: 'Komu, čo patrí v trojuholníku dieťa - rodič - škola.',
  text: `
Téma zodpovednosti je úzko spätá so školou. Je to prvá inštitúcia, s ktorou sa dieťa stretáva a formuje jeho vzťah ku vzdelávaniu a budúcej práci. Ako postupovať tak, aby z dieťaťa/ žiaka vyrástol zodpovedný a pre spoločnosť platný občan? Zo svojej skúsenosti môžem povedať, že tento proces dokážeme úspešne sabotovať ako rodičia, aj ako učitelia. Sú oblasti a témy, kde z detí snímame zodpovednosť a rozhodujeme za nich. V ťažkých situáciách by sme ako učitelia chceli, aby rodičia vyriešili naše problémy a naopak rodičia majú často strach otvorene a nedefenzívne komunikovať svoje predstavy. Komunikácia v trojuholníku rodič-škola-dieťa býva plná nedorozumení a stresu.

Psychologička, učiteľka, ktorá patrí medzi aktívnych členov Inštitútu psychoterapie a socioterapie, pravidelne prednáša a publikuje. Má vlastnú psychologickú prax - BALANS poradňa zdravého vývinu. Absolvovala tréning Johansenovej individualizovanej auditívnej stimulácie (JIAS), je INPP certifikovaná odborníčka a koordinátorka INPP Slovensko a Česko.
Je tiež mama dvoch detí.
  `,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presentations/p04_o_odnimani_zodpovednosti.js